import cl from "clsx";
import React, { forwardRef } from "react";
import { Slot } from "../slot/Slot.js";
import { createContext } from "../util/create-context.js";
const [RenameCSSProvider, useRenameCSS] = createContext({
    hookName: "useRenameCSS",
    name: "RenameCSS",
    providerName: "RenameCSSProvider",
    defaultValue: { cn: cl },
});
export const compositeClassFunction = (...inputs) => {
    const classes = cl(inputs)
        /* Replaces only if start of string  "navds- navds-"*/
        .replace(/^navds-/g, "aksel-")
        /* Replaces all " navds-" hits */
        .replace(/\snavds-/g, " aksel-");
    return classes.trim();
};
const RenameCSS = ({ children }) => {
    return (React.createElement(RenameCSSProvider, { cn: compositeClassFunction }, children));
};
const [ThemeProvider, useThemeInternal] = createContext({
    hookName: "useTheme",
    name: "ThemeProvider",
    providerName: "ThemeProvider",
});
const Theme = forwardRef((props, ref) => {
    var _a;
    const context = useThemeInternal(false);
    const { children, className, asChild = false, theme = (_a = context === null || context === void 0 ? void 0 : context.theme) !== null && _a !== void 0 ? _a : "light", hasBackground: hasBackgroundProp = true, } = props;
    const isRoot = context === undefined;
    const hasBackground = hasBackgroundProp !== null && hasBackgroundProp !== void 0 ? hasBackgroundProp : (isRoot && props.theme !== undefined);
    const SlotElement = asChild ? Slot : "div";
    return (React.createElement(ThemeProvider, { theme: theme },
        React.createElement(RenameCSS, null,
            React.createElement(SlotElement, { ref: ref, className: cl("aksel-theme", className, theme), "data-background": hasBackground }, children))));
});
export { Theme, useRenameCSS, useThemeInternal };
//# sourceMappingURL=Theme.js.map